import PropTypes from 'prop-types';
import "./button.css";

const Button = ({
    onClick,
    color = "primary",
    type = "button",
    children,
    className,
    ...props
}) => {
    const buttonStyle = {
        width: props.width ?? "100%",
        ...(props.style ?? {}),
    };

    return (
        <button
            type={type}
            onClick={onClick}
            style={buttonStyle}
            className={`csr-button ${className ?? ""} ${color ?? ""}`}
            {...props}
        >
            {children}
        </button>
    );
};

Button.propTypes = {
    onClick: PropTypes.func,
    color: PropTypes.string,
    type: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
        PropTypes.string
    ]),
    className: PropTypes.string,
    style: PropTypes.object,
    width: PropTypes.string
}

export default Button;
